(ns app.front.view.admin.commands.building-code-import
  (:require [ajax.core :refer [POST]]
            [app.front.ui :as ui]
            [app.front.view.group.admin.common :as acommon]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.icons :as i]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::state :-> ::state)

(rf/reg-event-db ::select-file
  (fn [db [_ file]]
    (if (get-in db [::state :uploading?])
      db
      (assoc db ::state {:file file}))))

(rf/reg-event-fx ::import
  (fn [{:keys [db]} _]
    (let [{:keys [file uploading?]} (::state db)]
      (when (and file (not uploading?))
        (POST "/api/command/admin/import-building-code-chunks"
          {:headers         {"Content-Type" "application/octet-stream"}
           :response-format :transit
           :body            file
           :handler         #(>evt [::import-success %])
           :error-handler   #(>evt [::import-failure %])})
        {:db (assoc db ::state {:file file :uploading? true})}))))

(defn- imported-message [tr imported-count]
  (tr [:admin-building-code/imported] [imported-count]))

(rf/reg-event-fx ::import-success
  (fn [{:keys [db]} [_ {:keys [imported-count]}]]
    {:db       (assoc db ::state {:imported-count imported-count})
     :dispatch [:notifications/add
                :toast
                :success
                :success
                [[:admin-building-code/imported] [imported-count]]]}))

(rf/reg-event-db ::import-failure
  (fn [db [_ {:keys [response status]}]]
    (assoc db ::state
           {:file      (get-in db [::state :file])
            :error-key (or (when (keyword? (:error response))
                             (:error response))
                           (if (= status 403)
                             :admin-building-code/error-forbidden
                             :admin-building-code/error-generic))})))

(defn- import-form []
  (let [tr                                                 (<sub [:tr])
        {:keys [file uploading? imported-count error-key]} (<sub [::state])]
    [:section
     {:data-guide-id          "building-code-dump-import"
      :data-guide-label       (tr [:admin-building-code/guide-label])
      :data-guide-description (tr [:admin-building-code/guide-description])}
     [:h2 (tr [:admin-building-code/heading])]
     [ui/help (tr [:admin-building-code/description])]
     [:div.flex.items-end.gap-4.mt-4
      [cc/file-uploader-button
       {:accept     [".sql"]
        :size       "field"
        :label-text (tr [:admin-building-code/choose-dump])
        :disabled   (boolean uploading?)
        :on-change  (fn [event]
                      (>evt [::select-file (-> event .-target .-files array-seq first)])
                      (set! (-> event .-target .-value) ""))}]
      [ui/modal-confirmation-button
       {:tr                  tr
        :id                  "import-building-code-dump"
        :trigger-button-text (tr [:admin-building-code/import])
        :trigger-button-opts {:kind     :danger
                              :size     :field
                              :icon     i/upload
                              :disabled (or (nil? file) (boolean uploading?))}
        :on-yes-click        #(>evt [::import])}
       [:div
        [:p (tr [:admin-building-code/confirm] [(some-> file .-name)])]
        [:p (tr [:admin-building-code/unchanged-warning])]]]]
     (when file
       [:p.mt-3 (tr [:admin-building-code/selected-file] [(.-name file)])])
     (when uploading?
       [:div.mt-3
        [cc/inline-loading {:description (tr [:admin-building-code/loading])}]])
     (when (some? imported-count)
       [:p.mt-3 {:role "status"} (imported-message tr imported-count)])
     (when error-key
       [:p.mt-3 {:role "alert"} (tr [error-key])])]))

(defn view [match]
  (let [tr (<sub [:tr])]
    (when (ff/enabled? :feature-flag.id/icc-cloudcheck-prototype)
      [acommon/admin-page (util/mmap {:title (tr [:admin-building-code/heading])} match)
       [import-form]])))

(def route
  {:name :view/admin.commands.building-code-import
   :view view})
